import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Masszazs from "@/pages/Masszazs";
import Fourlife from "@/pages/Fourlife";
import ForeverBeauty from "@/pages/ForeverBeauty";
import Blog from "@/pages/Blog";
import RegeneraciosKisokos from "@/pages/RegeneraciosKisokos";
import AromaFlowRecept from "@/pages/AromaFlowRecept";
import Adatkezeles from "@/pages/Adatkezeles";
import Hazirend from "@/pages/Hazirend";
import Rolunk from "@/pages/Rolunk";
import Ajandekkartya from "@/pages/Ajandekkartya";
import Admin from "@/pages/Admin";
import { ContentProvider } from "@/hooks/useSiteContent";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/masszazs" element={<Masszazs />} />
                  <Route path="/4life" element={<Fourlife />} />
                  <Route path="/forever" element={<ForeverBeauty />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/regeneracios-kisokos" element={<RegeneraciosKisokos />} />
                  <Route path="/aroma-flow-recept" element={<AromaFlowRecept />} />
                  <Route path="/adatkezeles" element={<Adatkezeles />} />
                  <Route path="/hazirend" element={<Hazirend />} />
                  <Route path="/rolunk" element={<Rolunk />} />
                  <Route path="/ajandekkartya" element={<Ajandekkartya />} />
                  <Route path="/installation/*" element={<Navigate to="/" replace />} />
                  <Route path="*" element={<Home />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            border: "1px solid #EAE5D9",
            color: "#1A2825",
            fontFamily: "'Manrope', sans-serif",
          },
        }}
      />
      </ContentProvider>
    </div>
  );
}

export default App;
